module.exports = __webpack_public_path__ + "static/media/buttonsounds12.fb0d7421.wav";